import { render } from "./BannerStudy.vue?vue&type=template&id=584e8b33&scoped=true"
import script from "./BannerStudy.vue?vue&type=script&lang=js"
export * from "./BannerStudy.vue?vue&type=script&lang=js"

import "./BannerStudy.vue?vue&type=style&index=0&id=584e8b33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584e8b33"]])

export default __exports__